import { connect } from 'react-redux';

import { openChat } from '../../actions/chat';
import { isRenterFormEnabled } from '../../selectors/isRenterFormEnabled';
import { getRosreestrInfo } from '../../selectors/offerData/getRosreestrInfo';
import { prefetchFormState } from '../../store/deal-rent';
import { setPhoneCollapse } from '../../store/phone_collapse';
import { HomeownerBlock, IHomeownerBlockProps } from './HomeownerBlock';

import type { DispatchReduxAction, IState } from '../../store';

export type THomeownerBlockContainerState = Pick<
  IHomeownerBlockProps,
  | 'abGroup'
  | 'agent'
  | 'offer'
  | 'user'
  | 'offerChat'
  | 'isAuthenticated'
  | 'isOfferOwnedByUser'
  | 'isAgentAvailable'
  | 'isDealRentFormEnabled'
  | 'rosreestrInfo'
>;

export type THomeownerBlockContainerDispatch = Pick<
  IHomeownerBlockProps,
  'setPhoneCollapse' | 'openDealRentForm' | 'openChat'
>;

export const mapStateToProps = (state: IState): THomeownerBlockContainerState => {
  const {
    abGroup,
    offerData: { agent, agentAvailability, offer, user },
    offerChat,
  } = state;

  return {
    abGroup,
    agent,
    offer,
    user,
    offerChat,
    isAuthenticated: !!(user && user.isAuthenticated),
    isOfferOwnedByUser: !!(user && user.isAuthenticated && user.realtyUserId === offer.userId),
    isAgentAvailable: !!(agentAvailability && agentAvailability.available),
    isDealRentFormEnabled: isRenterFormEnabled(state),
    rosreestrInfo: getRosreestrInfo(state),
  };
};

export const mapDispatchToProps = (dispatch: DispatchReduxAction): THomeownerBlockContainerDispatch => ({
  setPhoneCollapse: () => dispatch(setPhoneCollapse()),
  openDealRentForm: () => dispatch(prefetchFormState()),
  openChat: (type?: 'open_phone' | 'open_message') => dispatch(openChat(type)),
});

export const HomeownerBlockContainer = connect(mapStateToProps, mapDispatchToProps)(HomeownerBlock);
